/**
 * api接口统一管理
 */
import { get, getByParams, post } from './http';
export default {
    get, getByParams, post
}
